import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const useEmailSender = () => {
  const [isSending, setIsSending] = useState(false);

  // 컴포넌트 로드시 확인
  useEffect(() => {
    console.log('🔍 이메일 전송 모듈 로드됨');
    console.log('📧 Firebase 이메일 서버 사용: https://firebase-email-server.vercel.app');
  }, []);

  const showSwal = (msg, gubun) => {
    return withReactContent(Swal).fire({
      title: msg,
      confirmButtonText: "확인",
      confirmButtonColor: '#f97316',
      icon: gubun,
      focusConfirm: false,
    });
  };

  // Firebase 이메일 서버를 사용한 메일 전송
  const sendDirectMail = async (name, contact, projectDetails) => {
    setIsSending(true);
    try {
      console.log('=== Firebase 이메일 서버 호출 ===');
      
      // Firebase 이메일 서버로 전송
      const emailData = {
        to: 'sckcs@solcombine.com',
        subject: `[솔컴바인 프로젝트 문의] ${name}님의 문의사항`,
        text: `
프로젝트 문의가 접수되었습니다.

■ 문의자 정보 
- 성함: ${name}
- 연락처: ${contact}

■ 프로젝트 내용
${projectDetails}

감사합니다.
빠른 시일 내로 연락드리겠습니다.
        `,
        html: `
<h2>🚀 솔컴바인 프로젝트 문의</h2>
<div style="background: #f8f9fa; padding: 20px; border-radius: 8px; font-family: Arial, sans-serif;">
  <h3 style="color: #f97316;">■ 문의자 정보</h3>
  <p><strong>성함:</strong> ${name}</p>
  <p><strong>연락처:</strong> ${contact}</p>
  
  <h3 style="color: #f97316;">■ 프로젝트 내용</h3>
  <div style="background: white; padding: 15px; border-radius: 5px; border-left: 4px solid #f97316;">
    ${projectDetails.replace(/\n/g, '<br>')}
  </div>
  
  <hr style="margin: 20px 0;">
  <p style="color: #666; font-size: 14px;">
    감사합니다.<br>
    빠른 시일 내로 연락드리겠습니다.
  </p>
</div>
        `
      };

      console.log('이메일 데이터:', emailData);

      const response = await fetch('https://firebase-email-server.vercel.app/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(emailData),
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Firebase 이메일 서버 응답:', result);

      // 성공 처리
      let msg = '<div><span>메일이 성공적으로 전송되었습니다!</span><br/><span>빠른 시일내로 연락 드리겠습니다.</span></div>';
      await showSwal(msg, 'success');
      return { success: true };

    } catch (error) {
      console.error('Firebase 이메일 서버 호출 실패:', error);
      
      // 백업: Web3Forms 사용
      try {
        console.log('Web3Forms 백업 전송 시도...');
        
        const formData = new FormData();
        formData.append('access_key', 'eb24b8e6-1c6a-4d84-9c45-7f3a8e2b1d94');
        formData.append('name', name);
        formData.append('email', contact);
        formData.append('subject', `[솔컴바인 프로젝트 문의] ${name}님의 문의사항`);
        formData.append('message', `
프로젝트 문의가 접수되었습니다.

■ 문의자 정보
- 성함: ${name}
- 연락처: ${contact}

■ 프로젝트 내용
${projectDetails}

감사합니다.
        `);

        const backupResponse = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          body: formData
        });

        const backupResult = await backupResponse.json();

        if (backupResult.success) {
          let msg = '<div><span>메일이 성공적으로 전송되었습니다!</span><br/><span>빠른 시일내로 연락 드리겠습니다.</span></div>';
          await showSwal(msg, 'success');
          return { success: true };
        } else {
          throw new Error('Web3Forms 전송 실패');
        }
      } catch (backupError) {
        console.error('백업 전송도 실패:', backupError);
        let msg = '<div><span>메일 전송에 실패했습니다.</span><br/><span>직접 연락 부탁드립니다: sckcs@solcombine.com</span></div>';
        await showSwal(msg, 'error');
        return { success: false };
      }
    } finally {
      setIsSending(false);
    }
  };

  const sendEmail = async (name, contact, projectDetails) => {
    // 이미 전송 중이면 중단
    if (isSending) {
      let msg = '<div><span>메일을 보내는 중입니다...</span><br/><span>잠시만 기다려주세요.</span></div>';
      showSwal(msg, 'info');
      return { success: false };
    }

    if (name && contact && projectDetails) {
      // 연락처 유효성 검사
      if (contact.length < 10) {
        let msg = '<div><span>올바른 전화번호를 입력해주세요.</span></div>';
        showSwal(msg, 'warning');
        return { success: false };
      }

      // 입력값 디버깅
      console.log('=== 입력값 확인 ===');
      console.log('name:', name);
      console.log('contact:', contact);
      console.log('projectDetails:', projectDetails);

      // 서버로 직접 전송
      return await sendDirectMail(name, contact, projectDetails);
    } else {
      let msg = '<div><span>성함과 연락처를 입력해주시면 바로 연락드리겠습니다.</span></div>';
      showSwal(msg, 'warning');
      return { success: false };
    }
  };

  return {
    sendEmail,
    isSending
  };
};

export default useEmailSender; 